import React from 'react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { Box } from '@mui/material'
import DndItem from './DndItem'

interface Props {
    items: any[]
    setItems: (elements: any[]) => void
    setDraggedTopicIndex: React.Dispatch<React.SetStateAction<number>>
}

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)

    result.splice(endIndex, 0, removed)

    return result
}

const ItemList = React.memo(function ItemList({ items }: { items: any }) {
    return items.map((item: any, index: number) => (
        <DndItem
            item={item}
            index={index}
            key={item.courseTopicId}
        />
    ))
})

const DndCourseTopics: React.FC<Props> = ({
    items,
    setItems,
    setDraggedTopicIndex,
}) => {
    function onDragEnd(result) {
        if (!result.destination) {
            return
        }

        if (result.destination.index === result.source.index) {
            return
        }

        const newItems = reorder(
            items,
            result.source.index,
            result.destination.index,
        )

        setDraggedTopicIndex(result.destination.index)
        setItems(newItems)
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="list">
                {(provided) => (
                    <Box
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        sx={{ width: '100%' }}
                    >
                        <ItemList items={items} />
                        {provided.placeholder}
                    </Box>
                )}
            </Droppable>
        </DragDropContext>
    )
}

export default DndCourseTopics
